module.exports = __webpack_public_path__ + "static/img/i48_15x5.2d05c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/i48_15x5.png
// module id = EfaO
// module chunks = 101